import { Button, type ButtonProps, Icon } from '@imprivata-cloud/design-system';
import './no-inline-enrollment.less';

interface InformationDialogProps {
  title?: string;
  text?: string;
  buttonProps?: ButtonProps;
  status?: 'info' | 'warning';
}

export const InformationDialog = ({
  title,
  text,
  buttonProps,
  status = 'info',
}: InformationDialogProps) => {
  return (
    <div
      className={`information-dialog-root${status === 'warning' ? ' information-dialog-warning' : ''}`}
    >
      <Icon type={status} className="information-dialog-icon" />
      {title && <h2 className="information-dialog-title">{title}</h2>}
      {text && <p className="information-dialog-text">{text}</p>}
      {buttonProps && (
        <Button
          variant="primary"
          size="md"
          className="information-dialog-button"
          {...buttonProps}
        />
      )}
    </div>
  );
};
